import React from 'react';
import { Segment } from 'semantic-ui-react';
import { connect } from 'react-redux';

import { createTeam } from '../actions/teams';

import TeamForm from '../components/TeamForm';

const TeamCreate = props => (
  <Segment basic className="TeamCreate">
    <TeamForm team={{}} onSubmit={props.handleSubmit} />
  </Segment>
);

const mapStateToProps = state => ({
  team: state.teams.team
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  handleSubmit: attributes => {
    dispatch(createTeam(attributes)).then(data =>
      ownProps.history.push(`/team/${data.team.slug}`)
    );
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TeamCreate);



// WEBPACK FOOTER //
// ./src/containers/TeamCreate.js